import type {AxiosRequestConfig} from 'axios';
// import {Status, User} from '../users/interface';

export class GetPartnerConfigBuilder {
  private readonly partnerConfigRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/notification-service/partnerConfig',
  };
  build() {
    return this.partnerConfigRequest;
  }
}

export class UpdatePartnerConfigRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/notification-service/partnerConfig',
    data: {},
  };

  data(body: Status) {
    this.request.data = body;
    return this;
  }

  build() {
    return this.request;
  }
}
